import Vue                      from "vue";
import { 
  formatDateTime, 
  stringHelper,
  sizeHelper, 
  partInfoHelper
}                               from "@/components/mixins";
import { 
  LoadingSpinner,
  DnFunctionButton 
}       from "@/components/Elements"
import CurrencyText             from "@/components/Elements/CurrencyText.vue";
import DnNumberInput            from "@/components/Elements/DnNumberInput.vue"
import PartRequestQuote         from "@/components/PartRequestQuote/PartRequestQuote.vue"
import vSelect                  from "vue-select"
import { mapGetters }           from "vuex";

// icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default Vue.extend({
  name: "PartInfoGrid",
  components: {
    FontAwesomeIcon,
    vSelect,
    LoadingSpinner,
    CurrencyText,
    DnNumberInput,
    DnFunctionButton,
    PartRequestQuote
  },
  mixins: [formatDateTime, stringHelper, sizeHelper, partInfoHelper],
  computed: {
    ...mapGetters(["isPriceVisible"]),
    },
  created () {
  },
  methods:{
    isDropShipped(part){
      return part.FullPartDetails.ItemCategory === "ZDSH" || part.FullPartDetails.ItemCategory === "ZMDS";
    },
    warehoseStockTitle(part){
      if( this.isDropShipped(part)){
        return "Drop Shipped"
      }else{
        return "Facing Warehouse Stock:"
      }
    },
    warehouseStockDetail(part){  
      let detail = "";   
    
      if( part.FullPartDetails.WarehouseStockQuantities[0] != null){
        detail = part.FullPartDetails.WarehouseStockQuantities[0].WarehouseDescription + ":" + part.FullPartDetails.WarehouseStockQuantities[0].Quantity;
      }      
      
      // Dropship items display gridview stock differently
      if( this.isDropShipped(part) && part.FullPartDetails.ExternalStockQuantities.length > 0){
        let totalVendorStockQuantity = 0;
        part.FullPartDetails.ExternalStockQuantities.forEach(x => totalVendorStockQuantity += x.Quantity);
        
        detail = `Vendor Stock: ${totalVendorStockQuantity}`
      }    
      
      return detail;
    }
  }
});
